export const isInitialized = state => state.initialized;

export const get = state => state.item;

export const getEmailChange = state => state.email_change;
